import React from 'react';
import DetailCard, {
  DetailCardItem,
} from '@tcs/common/components/molecules/DetailCard';
import { Address } from '@tcs/client-portal-api/types/Address';
import { Unicode } from '@tcs/common/utils/unicode';

interface AddressCardProps {
  address: Address;
}

const AddressCard = ({ address }: AddressCardProps) => {
  return (
    <DetailCard title="Address">
      <DetailCardItem
        label="Address Line 1"
        value={address?.addressLine1}
        isPrivate
      />
      <DetailCardItem
        label="Address Line 2"
        value={address?.addressLine2 || Unicode.EmDash}
        isPrivate
      />
      <DetailCardItem label="City" value={address?.city} isPrivate />
      <DetailCardItem label="State" value={address?.state} isPrivate />
      <DetailCardItem label="Zip Code" value={address?.zipCode} isPrivate />
    </DetailCard>
  );
};

export default AddressCard;
